import {
  AfterContentInit,
  Component,
  ElementRef,
  inject,
  Renderer2,
  viewChild,
} from '@angular/core';
import { Button } from '../../../button/button.component';
import { ModalContainer } from '../../../modal/modal-container/modal-container.component';
import { ModalHeader } from '../../../modal/modal-header.component';
import { ModalAdapter } from '../../../modal/modal.adapter';

declare const daum: any;
declare global {
  interface Window {
    customThing?: string;
    daum: any;
  }
}

@Component({
  selector: 'app-address-modal',
  templateUrl: './daum-modal.component.html',
  styleUrls: ['./daum-modal.component.scss'],
  imports: [ModalHeader, ModalContainer, Button],
})
export class AddressModal extends ModalAdapter implements AfterContentInit {
  renderer = inject(Renderer2);
  container = viewChild<ElementRef>('container');

  ngAfterContentInit(): void {
    this.handlePostcode();
  }

  handlePostcode() {
    const elem = this.container()?.nativeElement;
    daum.postcode.load();
    new window.daum.Postcode({
      oncomplete: (data: any) => {
        this.modalService.close(data);
        elem.style.display = 'none';
      },
      width: '100%',
      height: '100%',
      maxSuggestItems: 5,
    }).embed(elem);

    /**
     * 창크기 조정, 팝업창 센터로
     */
    this.renderer.setStyle(elem, 'display', 'block');
  }
}
